"use strict";

import $ from "jquery";

export default function settingDetails(scope) {
    $(document).on("click", scope.setting, function (e) {
        e.preventDefault();

        const setting = $(this);
        const toggle = setting.find(scope.toggle);
        const details = setting.find(scope.details);

        if (e.target === toggle[0] || e.target === toggle[1]) {
            details.slideToggle(scope.speed);
        }
    });
}
